var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgChartBar = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M14.688 6.188h-3.626v9h4.126v-8.5a.5.5 0 0 0-.5-.5Zm-7.75 9v-5.25H3.313a.5.5 0 0 0-.5.5v4.75z" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M10.563 2.813H7.437a.5.5 0 0 0-.5.5v11.875h4.126V3.313a.5.5 0 0 0-.5-.5Z" })] }))); };
export default SvgChartBar;
